"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FastModeBuildDemotedEvent = exports.FastModeBuildCompletedEvent = exports.FastModeAnalysisDispatchedEvent = void 0;
const zod_1 = require("zod");
const analysis_type_1 = require("../../AnalysisResult/analysis-type");
const build_status_1 = require("../../Types/build-status");
const event_1 = require("../event");
exports.FastModeAnalysisDispatchedEvent = (0, event_1.createEventClass)('FastModeAnalysisDispatchedEvent', zod_1.z.object({
    buildId: zod_1.z.string(),
    projectId: zod_1.z.string(),
    organizationId: zod_1.z.string(),
    workflowId: zod_1.z.string(),
}));
exports.FastModeBuildCompletedEvent = (0, event_1.createEventClass)('FastModeBuildCompletedEvent', zod_1.z.object({
    buildId: zod_1.z.string(),
    analysisType: analysis_type_1.AnalysisTypeSchema.optional(),
    resultCount: zod_1.z.number().optional(),
    aiStagesCompleted: zod_1.z.number().optional(),
    aiSubjectsProcessed: zod_1.z.number().optional(),
    aiSubjectsFailed: zod_1.z.number().optional(),
}));
exports.FastModeBuildDemotedEvent = (0, event_1.createEventClass)('FastModeBuildDemotedEvent', zod_1.z.object({
    buildId: zod_1.z.string(),
    reason: zod_1.z.string(),
    parkedStatus: build_status_1.buildStatusSchema,
}));
//# sourceMappingURL=fast-mode-events.js.map